<template>
	<v-dialog v-model="localDialog" max-width="400px" transition="dialog-top-transition" persistent>
		<v-card>
			<v-card-title class="mx-auto primary2 py-1 font-size16 text-color-white">
				{{ $t('change') }} {{ $t('status') }}
			</v-card-title>
			<v-card-text class="py-5">{{ confirmQuestion ? $t(confirmQuestion) : $t('changeStatusQuestion') }}</v-card-text>
			<v-card-actions class="d-flex justify-center">
				<v-btn @click="$emit('confirmToggleStatus')" color="primary2" class="text-color-white">{{ $t('yes') }}</v-btn>
				<v-btn @click="cancelToggleStatus">{{ $t('no') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapState } from 'vuex';

export default {
	props: ['dialog', 'confirmQuestion'],
	data () {
		return {
			localDialog: this.dialog,
		};
	},
	methods: {
		async getPatients () {
			const hospitalIdFromStore = this.userData.hospitalAssignedData.id;
			await this.$store.dispatch('hospitals/getRelatedPatientsV4', hospitalIdFromStore).then(() => {
				this.loading = false;
			});
		},
		cancelToggleStatus () {
			this.localDialog = false;
		},
	},
	computed: {
		...mapState({
			userData: (state) => state.authentication.userData,
		}),
	},
	watch: {
		dialog (val) {
			this.localDialog = val;
		},
		localDialog (val) {
			this.$emit('update:dialog', val);
		},
	},
};
</script>
